var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H9C10.6569 22 12 20.6569 12 19V18.1818C12 17.6295 11.5523 17.1818 11 17.1818C10.4477 17.1818 10 17.6295 10 18.1818V19C10 19.5523 9.55228 20 9 20H5C4.44772 20 4 19.5523 4 19V5C4 4.44772 4.44772 4 5 4H9C9.55229 4 10 4.44771 10 5V5.81818C10 6.37047 10.4477 6.81818 11 6.81818C11.5523 6.81818 12 6.37047 12 5.81818V5C12 3.34314 10.6569 2 9 2H5Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7875 6.67397C15.4153 6.26596 15.4443 5.63346 15.8524 5.26124C16.2604 4.88902 16.8929 4.91804 17.2651 5.32604L22.7388 11.326C23.0871 11.7078 23.0871 12.2922 22.7388 12.674L17.2651 18.674C16.8929 19.082 16.2604 19.111 15.8524 18.7388C15.4443 18.3666 15.4153 17.7341 15.7875 17.326L19.7341 13H9C8.44772 13 8 12.5523 8 12C8 11.4477 8.44772 11 9 11H19.7341L15.7875 6.67397Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.786a6caef98802d94a3759d76eaa66a3.svg";
export { ForwardRef as ReactComponent };